import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { CancelInterviewRoutes } from './index';
import { CancelInterviewComponent } from './cancel-interview.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        RouterModule.forChild(CancelInterviewRoutes),
        TranslateModule
    ],
    declarations: [
        CancelInterviewComponent
    ],
    exports: [
        CancelInterviewComponent
    ]
})
export class CancelInterviewModule {}
